import type { ConsentStatusView, ConsentTone } from "../lib/eam";

const TONE: Record<ConsentTone, string> = {
  ok: "bg-green-100 text-green-800",
  warn: "bg-yellow-100 text-yellow-800",
  bad: "bg-red-100 text-red-800",
  grey: "bg-gray-100 text-gray-800",
};

/** Step 1's read-access tag, with each note as a line under it. */
export default function ReadAccessStatus({ view }: { view: ConsentStatusView }) {
  return (
    <div className="mt-2">
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${TONE[view.tone]}`}>{view.label}</span>
      {view.notes.map((note) => (
        <p key={note} className="mt-1 text-sm text-gray-500">
          {note}
        </p>
      ))}
    </div>
  );
}
